import { useLocation } from 'react-router';

import { resolveRouteKey } from '@/features/i18n';

import LanguageSwitcher from './LanguageSwitcher';

export default function PublicUtilityBar() {
  const { pathname } = useLocation();
  const isBlog = resolveRouteKey(pathname).startsWith('blog.');

  return (
    <div className="public-utility-shell" data-testid="public-utility-bar">
      <div className="public-utility-bar">
        <LanguageSwitcher navigationMode={isBlog ? 'document' : 'spa'} />
      </div>
    </div>
  );
}
